import { css } from '@linaria/core';

const modalDrawer = css``;
const drawer = css``;
const fluid = css``;

const drawerCard = css`
  --drawer-card-dimensions: 320px;
  --drawer-transition-duration: 250ms;
  --drawer-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  &.${fluid} {
    --drawer-card-dimensions: auto;
  }
  .${modalDrawer}.${drawer} & {
    position: fixed;
    overflow-y: auto;
    overflow-x: hidden;
    transition-property: transform;
    transition-timing-function: var(--drawer-transition-timing-function);
    transition-duration: var(--drawer-transition-duration);
    padding: 16px;
    max-height: initial;
    border-radius: 0;

    &.is-right {
      border-right: 0;
      right: 0;
      transform: translateX(100%);
    }

    &.is-left {
      border-left: 0;
      left: 0;
      transform: translateX(-100%);
    }

    &.is-right,
    &.is-left {
      border-bottom: 0;
      border-top: 0;
      bottom: 0;
      top: 0;
      width: var(--drawer-card-dimensions);
      &.open {
        transform: translateX(0%);
      }
    }

    &.is-top,
    &.is-bottom {
      border-left: 0;
      border-right: 0;
      height: var(--drawer-card-dimensions);
      left: 0;
      right: 0;
      &.open {
        transform: translateY(0%);
      }
    }

    &.is-top {
      top: 0;
      border-top: 0;
      transform: translateY(-100%);
    }

    &.is-bottom {
      border-bottom: 0;
      bottom: 0;
      transform: translateY(100%);
    }
  }
`;

export default {
  modalDrawer,
  drawer,
  drawerCard,
  fluid,
};
